import { FC, useContext, useEffect, useMemo } from 'react';
import { Route, Switch, useParams, useHistory, Redirect } from 'react-router-dom';
import MenuTabs from '../../../lib/components/MenuTabs';
import AgendaVideoData from '../types/AgendaVideoData';
import AgendaFlashcardsData from '../types/AgendaFlashcardsData';
import AgendaMindMapsData from '../types/AgendaMindMapsData';
import AgendaTextsData from '../types/AgendaTextsData';
import { PrivateContext } from '../../../Private.context';
import { TheoreticalLessonNavigator } from '../_components/TheoreticalLessonNavigator';
import AgendaQuestionsData from '../types/AgendaQuestionsData';

const AgendaTheoreticalStudy: FC = () => {
  const { agenda } = useContext(PrivateContext);
  const params = useParams<{ lessonId: string }>();
  const history = useHistory();

  useEffect(() => {
    if (!params.lessonId && agenda) {
      history.push(`/agenda/estudo-teorico/${agenda.theoreticalStudy[0]?.lessonId ?? ''}${window.location.search}`);
    }
  }, [agenda, history, params.lessonId]);

  const menuItems = useMemo(() => {
    if (agenda) {
      const lesson = agenda.theoreticalStudy.find(item => item.lessonId === params.lessonId);
      return ({
        questao: Boolean(lesson && lesson.questions.length > 0),
        video: Boolean(lesson && lesson.videos.length > 0),
        apostila: Boolean(lesson && lesson.texts.length > 0),
        'mapa-mental': Boolean(lesson && lesson.mindmaps.length > 0),
        flashcard: Boolean(lesson && lesson.flashcards.length > 0),
      });
    }

    return {
      questao: false,
      video: false,
      apostila: false,
      'mapa-mental': false,
      flashcard: false,
    };
  }, [agenda, params.lessonId]);

  const contentType = useMemo(() => {
    return Object.entries(menuItems).filter(item => item[1])[0]?.[0];
  }, [menuItems]);

  // const lessonClassification = useMemo(() => {
  //   if (params.lessonId && agenda) {
  //     const currentLesson = agenda.theoreticalStudy.find(l => l.lessonId === params.lessonId);
  //     return currentLesson?.classification.join('|') ?? '';
  //   }
  //   return '';
  // }, [agenda, params.lessonId]);

  // const classification = useMemo(() => {
  //   if (params.lessonId && agenda) {
  //     const currentLesson = agenda.theoreticalStudy.find(l => l.lessonId === params.lessonId);
  //     return currentLesson?.classification.filter(e => e !== '') || [];
  //   }
  //   return [];
  // }, [agenda, params.lessonId]);

  return (
    <>
      <TheoreticalLessonNavigator
        lessons={agenda?.theoreticalStudy}
        type="study"
      />
      <MenuTabs
        menuItems={menuItems}
        path={`/agenda/estudo-teorico/${params.lessonId}`}
      />
      <Switch>
        <Route
          exact
          path="/agenda/estudo-teorico/:lessonId"
          render={() => (
            <Redirect
              to={`/agenda/estudo-teorico/${params.lessonId}/${contentType ?? ''}${window.location.search}`}
            />
          )}
        />
        <Route path="/agenda/estudo-teorico/:lessonId/video">
          <AgendaVideoData />
        </Route>
        <Route path="/agenda/estudo-teorico/:lessonId/apostila">
          {/* <ForumWrapper
            key="ParetoGuide"
            forumId={params.lessonId}
            forumTag={lessonClassification}
            contentType="ParetoGuide"
            classification={classification}
          > */}
          <AgendaTextsData />
          {/* </ForumWrapper> */}
        </Route>
        <Route path="/agenda/estudo-teorico/:lessonId/mapa-mental">
          {/* <ForumWrapper
            key="MindMap"
            forumId={params.lessonId}
            forumTag={lessonClassification}
            contentType="MindMap"
            classification={classification}
          > */}
          <AgendaMindMapsData />
          {/* </ForumWrapper> */}
        </Route>
        <Route path="/agenda/estudo-teorico/:lessonId/flashcard">
          <AgendaFlashcardsData />
        </Route>
        <Route
          path="/agenda/estudo-teorico/:lessonId/questao"
          component={AgendaQuestionsData}
        />
      </Switch>
    </>
  );
};

export default AgendaTheoreticalStudy;
